import { get, post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'
import { enrichSalesOrder } from '../enrich-sales-order'


export const findSalesOrderRequest = (salesOrderId) => ({
    type: type.FIND_SALES_ORDER_REQUEST,
    payload: {
        salesOrderId,
    },
})

export const findSalesOrderSuccess = (salesOrder) => (dispatch, getState) => {
    enrichSalesOrder(getState(), salesOrder)
    dispatch({
        type: type.FIND_SALES_ORDER_SUCCESS,
        payload: {
            salesOrder,
        },
    })
}

export const findSalesOrderError = (error) => ({
    type: type.FIND_SALES_ORDER_ERROR,
    payload: {
        error,
    },
})

export const findSalesOrder = (salesOrderId) => (dispatch, getState) => {
    dispatch(findSalesOrderRequest(salesOrderId))

    get('/api/sales-order/find-by-id?salesOrderId=' + salesOrderId)
        .then(salesOrder => {
            dispatch(findSalesOrderSuccess(salesOrder))
        })
        .catch(error => {
            dispatch(findSalesOrderError(error))
        })
}

export const changeSalesOrderCustomer = (name, value) => ({
    type: type.CHANGE_SALES_ORDER_CUSTOMER,
    payload: {
        name,
        value,
    },
})

export const saveSalesOrderCustomerRequest = () => ({
    type: type.SAVE_SALES_ORDER_CUSTOMER_REQUEST,
})

export const saveSalesOrderCustomerSuccess = (salesOrderCustomer) => ({
    type: type.SAVE_SALES_ORDER_CUSTOMER_SUCCESS,
    payload: {
        salesOrderCustomer,
    },
})

export const saveSalesOrderCustomerError = (error) => ({
    type: type.SAVE_SALES_ORDER_CUSTOMER_ERROR,
    payload: {
        error,
    },
})

export const saveSalesOrderCustomer = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    if (!hasChanged) {
        return
    }

    const salesOrderCustomer = selector.selectSalesOrderCustomer(state)

    dispatch(saveSalesOrderCustomerRequest())
    post('/api/sales-order/customer/save', salesOrderCustomer)
        .then(salesOrderCustomer => {
            dispatch(saveSalesOrderCustomerSuccess(salesOrderCustomer))
        })
        .catch(error => {
            dispatch(saveSalesOrderCustomerError(error))
        })
}

export const changeSalesOrder = (name, value) => ({
    type: type.CHANGE_SALES_ORDER,
    payload: {
        name,
        value,
    },
})

export const saveSalesOrderRequest = () => ({
    type: type.SAVE_SALES_ORDER_REQUEST,
})

export const saveSalesOrderSuccess = (salesOrder) => ({
    type: type.SAVE_SALES_ORDER_SUCCESS,
    payload: {
        salesOrder,
    },
})

export const saveSalesOrderError = (error) => ({
    type: type.SAVE_SALES_ORDER_ERROR,
    payload: {
        error,
    },
})

export const saveSalesOrder = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    if (!hasChanged) {
        return
    }

    const salesOrder = selector.selectSalesOrder(state)

    dispatch(saveSalesOrderRequest())
    post('/api/sales-order/save', salesOrder)
        .then(salesOrder => {
            enrichSalesOrder(state, salesOrder)
            dispatch(saveSalesOrderSuccess(salesOrder))
        })
        .catch(error => {
            dispatch(saveSalesOrderError(error))
        })
}


export const addSentEmail = (sentEmail) => ({
    type: type.ADD_SENT_EMAIL,
    payload: {
        sentEmail,
    },
})


export const addInvoice = (invoice) => ({
    type: type.ADD_INVOICE,
    payload: {
        invoice,
    },
})


export const addShipment = (shipment) => ({
    type: type.ADD_SHIPMENT,
    payload: {
        shipment,
    },
})

export const hydrateSalesOrderCustomerContact = () => ({
    type: type.HYDRATE_SALESORDER_CUSTOMER_CONTACT
})

export const changeSalesOrderCustomerContact = (name, value) => ({
    type: type.CHANGE_SALES_ORDER_CUSTOMER_CONTACT,
    payload: {
        name,
        value,
    },
})

export const saveSalesOrderCustomerContact = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    if (!hasChanged) {
        return
    }

    dispatch(saveSalesOrderCustomerRequest())

    const contact = selector.selectSalesOrderCustomerContact(state)
    post('/api/sales-order/customer-contact/save', contact)
        .then(salesOrderCustomer => {
            dispatch(saveSalesOrderCustomerSuccess(salesOrderCustomer))
        })
        .catch(error => {
            dispatch(saveSalesOrderCustomerError(error))
        })
        .finally( () => {
            dispatch(hydrateSalesOrderCustomerContact())
        })
}



// WEBPACK FOOTER //
// ./src/modules/sales-order/state/detail/action.js